import { render, staticRenderFns } from "./posBankTransactionDetails.vue?vue&type=template&id=385eca1d&"
import script from "./posBankTransactionDetails.vue?vue&type=script&lang=js&"
export * from "./posBankTransactionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports